import React, { useState, useEffect, useRef } from 'react';
import { MessageSquare, X, Phone, Mail } from 'lucide-react';

export default function SupportButton() {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current && 
        !popupRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)
      ) {
        setShowPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={() => setShowPopup(!showPopup)}
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-black text-white px-4 py-3 rounded-xl shadow-lg hover:bg-gray-800 transition-colors"
      >
        <MessageSquare size={20} />
        <span className="font-medium">Support</span>
      </button>

      {/* Support Popup */}
      {showPopup && (
        <div 
          ref={popupRef}
          className="fixed bottom-24 right-6 z-40 bg-white rounded-xl shadow-lg p-4 w-64 animate-fadeIn"
        >
          <button 
            onClick={() => setShowPopup(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            <X size={16} />
          </button>
          <div className="flex flex-col gap-3">
            <h3 className="font-bold text-gray-900">Contact Support</h3>
            <p className="text-sm text-gray-600">
              24/7 support available with 5-60min response time
            </p>
            <div className="flex flex-col gap-2 mt-1">
              <a 
                href="mailto:bookings@privatecharterx.com"
                className="flex items-center gap-2 px-3 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors text-sm"
              >
                <Mail size={16} />
                <span>Email Support</span>
              </a>
              <a 
                href="tel:+41447978853"
                className="flex items-center gap-2 px-3 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition-colors text-sm"
              >
                <Phone size={16} />
                <span>+41 44 797 88 53</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}